// extracted by mini-css-extract-plugin
var _1 = "amex-_alF_";
var _2 = "bot-KHwuO";
var _3 = "bottom-oZWFq";
var _4 = "carts-d80zS";
var _5 = "close-Es3Vp";
var _6 = "contacts-zyc6H";
var _7 = "discover-_LhGp";
var _8 = "email-VGaDe";
var _9 = "footer-nrUeo";
var _a = "item-MwmQZ";
var _b = "logo-tL92Q";
var _c = "mastercard-IIwJ3";
var _d = "menu-N1xWg";
var _e = "open-OXHnL";
var _f = "paypal-QuC0v";
var _10 = "policy-JBALd";
var _11 = "sub-GSi7Z";
var _12 = "title-PhNfV";
var _13 = "visa-eG7_Z";
var _14 = "wrapper-Xezld";
export { _1 as "amex", _2 as "bot", _3 as "bottom", _4 as "carts", _5 as "close", _6 as "contacts", _7 as "discover", _8 as "email", _9 as "footer", _a as "item", _b as "logo", _c as "mastercard", _d as "menu", _e as "open", _f as "paypal", _10 as "policy", _11 as "sub", _12 as "title", _13 as "visa", _14 as "wrapper" }
